const CONSTANTS = {
  TOKEN: 'TOKEN',
  SMS_COUNTDOWN: 'SMS_COUNTDOWN'
};

export default CONSTANTS;
